if (!customElements.get("custom-show-more-button")) {
  /**
   * 含有 data-auto-init 属性时，自动初始化，否则需要调用 .init() 方法初始化
   */
  class CustomShowMoreButton extends HTMLElement {
    constructor() {
      super();
      if (this.getAttribute('data-auto-init')) {
        this.init();
      }
    }

    init() {
      this.isShow = false;
      this.showButton = this.querySelector('.learn-more-button__show');
      this.hideButton = this.querySelector('.learn-more-button__hide');
      this.target = this.previousElementSibling.hasAttribute('data-show-content')
        ? this.previousElementSibling
        : null;
      this.targetInner = this.target.querySelector('[data-show-content-inner]');
      this.targetInnerCopy = this.target.querySelector('[data-show-content-inner-copy]');
      this.targetInnerCopy.innerHTML = this.targetInner.innerHTML;

      this.showContent = this.showContent.bind(this);
      this.hideContent = this.hideContent.bind(this);
      this.toggleContent = this.toggleContent.bind(this);

      if (this.target) {
        this.showButton.addEventListener('click', this.toggleContent);
        this.hideButton.addEventListener('click', this.toggleContent);
        if (this.targetInnerCopy.getBoundingClientRect().height <= this.targetInner.getBoundingClientRect().height) {
          this.style.display = 'none';
          this.target.classList.add('active');
        }
        // console.log('显示更多按钮已连接。');
      } else {
        // console.warn('找不到目标元素。');
      }
    }

    connectedCallback() { }

    disconnectedCallback() {
      if (this.target) {
        this.showButton.removeEventListener('click', this.toggleContent);
        this.hideButton.removeEventListener('click', this.toggleContent);
      }
    }

    toggleContent() {
      if (this.isShow) {
        this.hideContent();
      } else {
        this.showContent();
      }
    }

    showContent() {
      this.target.classList.add('active');
      this.showButton.style.display = 'none';
      this.hideButton.style.display = 'none';
      this.isShow = true;
    }

    hideContent() {
      this.target.classList.remove('active');
      this.showButton.style.display = 'flex';
      this.hideButton.style.display = 'none';
      this.isShow = false;
    }
  }

  customElements.define('custom-show-more-button', CustomShowMoreButton);
}